import React from "react";
import { useFormState } from "react-final-form";
import CustomDatePickerInput from "./CustomDatePickerInput";

export enum EType {
  Early = "early",
  Late = "late",
}

interface ICustomRegistrationDate {
  source: string;
  comparison?: string;
  type: EType;
  label?: string;
}

const CustomRegistrationDateInput = ({
  source,
  label,
  comparison,
  type,
}: ICustomRegistrationDate) => {
  const { values } = useFormState();

  const maxEarlyDate = values.startDate
    ? new Date(values.startDate)
    : new Date();
  maxEarlyDate.setDate(maxEarlyDate.getDate() - 1);
  const maxEarlyDateStr = maxEarlyDate.toISOString().slice(0, 10);

  return (
    <>
      {type === EType.Early ? (
        <>
          {comparison ? (
            <CustomDatePickerInput
              name={source}
              label={label}
              min={values[comparison]}
              max={maxEarlyDateStr}
            />
          ) : (
            <CustomDatePickerInput
              name={source}
              label={label}
              max={maxEarlyDateStr}
            />
          )}
        </>
      ) : (
        <CustomDatePickerInput
          name={source}
          label={label}
          min={values.startDate}
          max={values.endDate}
        />
      )}
    </>
  );
};

export default CustomRegistrationDateInput;
